var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplimateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 285.24 285.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Complimate_Gradient_Swatch);\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: url(#Complimate_Gradient_Swatch1);\n      }\n\n      .st3 {\n        fill: url(#Complimate_Gradient_Swatch4);\n      }\n\n      .st4 {\n        fill: url(#Complimate_Gradient_Swatch3);\n      }\n\n      .st5 {\n        fill: url(#Complimate_Gradient_Swatch2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Complimate_Gradient_Swatch",
    "data-name": "Complimate Gradient Swatch",
    x1: 30.65,
    y1: 253.4,
    x2: 244.54,
    y2: 41.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#059490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6dc9c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Complimate_Gradient_Swatch1",
    "data-name": "Complimate Gradient Swatch",
    x1: -1.12,
    y1: 221.3,
    x2: 212.78,
    y2: 9.67,
    xlinkHref: "#Complimate_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Complimate_Gradient_Swatch2",
    "data-name": "Complimate Gradient Swatch",
    x1: 11.53,
    y1: 234.08,
    x2: 225.42,
    y2: 22.45,
    xlinkHref: "#Complimate_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Complimate_Gradient_Swatch3",
    "data-name": "Complimate Gradient Swatch",
    x1: 24.17,
    y1: 246.86,
    x2: 238.06,
    y2: 35.23,
    xlinkHref: "#Complimate_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Complimate_Gradient_Swatch4",
    "data-name": "Complimate Gradient Swatch",
    x1: 63.9,
    y1: 287.01,
    x2: 277.79,
    y2: 75.39,
    xlinkHref: "#Complimate_Gradient_Swatch"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.82,106.13v-23.11c0-22.98-18.63-41.61-41.61-41.61h-119.19c-22.98,0-41.61,18.63-41.61,41.61v119.19c0,22.98,18.63,41.61,41.61,41.61h119.19c22.98,0,41.61-18.63,41.61-41.61v-31.98c0-1.78-2.16-2.68-3.42-1.42l-12.48,12.49c-.38.38-.59.89-.59,1.42v19.5c0,13.87-11.25,25.12-25.12,25.12h-119.19c-13.87,0-25.12-11.25-25.12-25.12v-119.19c0-13.87,11.25-25.12,25.12-25.12h119.19c13.87,0,25.12,11.25,25.12,25.12v35.57c0,1.78,2.16,2.68,3.42,1.42l12.48-12.46c.38-.38.59-.89.59-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.02,94.01h-100.31c-4.55,0-8.25-3.69-8.25-8.25s3.69-8.25,8.25-8.25h100.31c4.55,0,8.25,3.69,8.25,8.25s-3.69,8.25-8.25,8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.75,133.29h-72.04c-4.55,0-8.25-3.69-8.25-8.25s3.69-8.25,8.25-8.25h72.04c4.55,0,8.25,3.69,8.25,8.25s-3.69,8.25-8.25,8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.48,172.56h-43.77c-4.55,0-8.25-3.69-8.25-8.25s3.69-8.25,8.25-8.25h43.77c4.55,0,8.25,3.69,8.25,8.25s-3.69,8.25-8.25,8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.62,124.5l-22.8,22.8-16.49,16.5-33.48,33.49c-1.6,1.56-3.66,2.37-5.72,2.37-1.66,0-3.32-.53-4.76-1.6l-28.18-28.16c-1.02-1.02-1.86-2.18-2.38-3.5-.19-.47-.33-.93-.38-1.31-.06-.53-.06-1.79,0-2.32.54-4.13,4.28-6.68,8.04-6.68,2.04,0,4.09.75,5.64,2.4l22.12,22.12,39.11-39.08,5.56-5.55,10.94-10.91,1.18-1.18,10.31-10.31c.93-.92,2.02-1.71,3.25-2.14.87-.3,1.73-.44,2.57-.44,6.19,0,10.82,7.74,5.48,13.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.82,106.13v-23.11c0-22.98-18.63-41.61-41.61-41.61h-119.19c-22.98,0-41.61,18.63-41.61,41.61v119.19c0,22.98,18.63,41.61,41.61,41.61h119.19c22.98,0,41.61-18.63,41.61-41.61v-31.98c0-1.78-2.16-2.68-3.42-1.42l-12.48,12.49c-.38.38-.59.89-.59,1.42v19.5c0,13.87-11.25,25.12-25.12,25.12h-119.19c-13.87,0-25.12-11.25-25.12-25.12v-119.19c0-13.87,11.25-25.12,25.12-25.12h119.19c13.87,0,25.12,11.25,25.12,25.12v35.57c0,1.78,2.16,2.68,3.42,1.42l12.48-12.46c.38-.38.59-.89.59-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.02,94.01h-100.31c-4.55,0-8.25-3.69-8.25-8.25s3.69-8.25,8.25-8.25h100.31c4.55,0,8.25,3.69,8.25,8.25s-3.69,8.25-8.25,8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.75,133.29h-72.04c-4.55,0-8.25-3.69-8.25-8.25s3.69-8.25,8.25-8.25h72.04c4.55,0,8.25,3.69,8.25,8.25s-3.69,8.25-8.25,8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.48,172.56h-43.77c-4.55,0-8.25-3.69-8.25-8.25s3.69-8.25,8.25-8.25h43.77c4.55,0,8.25,3.69,8.25,8.25s-3.69,8.25-8.25,8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.62,124.5l-22.8,22.8-16.49,16.5-33.48,33.49c-1.6,1.56-3.66,2.37-5.72,2.37-1.66,0-3.32-.53-4.76-1.6l-28.18-28.16c-1.02-1.02-1.86-2.18-2.38-3.5-.19-.47-.33-.93-.38-1.31-.06-.53-.06-1.79,0-2.32.54-4.13,4.28-6.68,8.04-6.68,2.04,0,4.09.75,5.64,2.4l22.12,22.12,39.11-39.08,5.56-5.55,10.94-10.91,1.18-1.18,10.31-10.31c.93-.92,2.02-1.71,3.25-2.14.87-.3,1.73-.44,2.57-.44,6.19,0,10.82,7.74,5.48,13.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplimateWhite);
export default __webpack_public_path__ + "static/media/complimate_white.c2b231936f2b3bb08f5335285c0dfa1c.svg";
export { ForwardRef as ReactComponent };